import styled from '@emotion/styled'
import {theme} from '../../../../accountManagement/theme'

export const GridSlot = styled.div`
  grid-column: 1 / -1;
`

export const PanelWrapper = styled.div`
  display: flex;
  background: ${theme.colors.bg.primary};
  border-radius: ${theme.radii.lg};
  box-shadow: inset 0 0 0 1px ${theme.colors.action.primary},
    0px 4px 4px 0px #00000021;
  overflow: hidden;
  padding: ${theme.space[2.5]};
  gap: ${theme.space[2.5]};
`

export const PanelLeft = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2.5]};
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.space[1]};
`

export const PanelTitle = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  line-height: 1.2;
  color: ${theme.colors.text.primary};
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  margin-left: auto;
  color: #b3b3b3;
  font-size: 18px;

  svg {
    width: 18px;
    height: 18px;
  }
`

export const PlanOption = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[2.5]};
  background: ${({isAdded}) => (isAdded ? theme.palette.neutral[100] : 'none')};
  border: none;
  box-shadow: inset 0 0 0 1px
    ${({isActive}) =>
      isActive ? theme.colors.action.primary : theme.colors.border.default};
  border-radius: ${theme.radii.md};
  cursor: ${({isAdded, isDisabled}) =>
    isAdded || isDisabled ? 'not-allowed' : 'pointer'};
  padding: ${theme.space[3]} ${theme.space[2.5]};
  width: 100%;
  text-align: left;
  align-items: center;
  opacity: ${({isAdded, isDisabled}) => (isAdded || isDisabled ? 0.5 : 1)};
  transition: box-shadow ${theme.transitions.fast};

  &:hover:not(:disabled) {
    box-shadow: inset 0 0 0 1px ${theme.colors.action.primary};
  }
`

export const PlanText = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  line-height: 1;
  color: ${({isDisabled}) =>
    isDisabled ? '#A3A5A7' : theme.colors.text.primary};
`

export const PlanPeriod = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.bold};
  line-height: 1;
  color: ${theme.palette.neutral[300]};
`

export const PlanArrow = styled.span`
  display: flex;
  align-items: center;
  color: ${({isActive}) =>
    isActive ? theme.colors.action.primary : '#D6DEF0'};
`

export const PanelRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2.5]};
`

export const ProductOptions = styled.div`
  display: flex;
  flex-direction: column;
  background: ${theme.colors.bg.brand};
  border-radius: ${theme.radii.md};
  padding: ${theme.space[2.5]};
  gap: ${theme.space[2.5]};
`

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[4]};
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: ${theme.space[2.5]};
`

export const FieldRow = styled.div`
  display: flex;
  gap: ${theme.space[2.5]};
`

export const AddToOrderRow = styled.div`
  display: flex;
`

export const NoSelectionMessage = styled.p`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.muted};
  margin: 0;
`

export const EntitlementsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1]};
`

export const EntitlementsTitle = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.muted};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

export const EntitlementItem = styled.li`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.primary};
  display: flex;
  align-items: center;
  gap: ${theme.space[1.5]};
`

export const AddonStepperList = styled.div`
  display: flex;
  width: fit-content;
  max-width: 100%;
  flex-direction: column;
  gap: ${theme.space[2.5]};
`

export const AddonStepperRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${theme.space[8]};
`

export const AddonStepperInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const AddonStepperName = styled.span`
  display: flex;
  align-items: center;
  min-height: 22px; /* match the stepper height so the name lines up with it */
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
`

export const AddonStepperPrice = styled.span`
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.text.muted};
`
